import React from 'react';

import {
  Typography,
  ListItemSecondaryAction,
  Help,
  Stack,
  VirtualizedList,
} from '@gogame/components';

import CategoryActions from './Actions';

const renderLabel = (params) => {
  const { name, subCategories, description } = params;
  const subCategoryCount = subCategories.length;
  return (
    <Stack
      sx={{ flexGrow: 1, minWidth: 0, gap: 1 }}
      as={'span'}
      direction={'row'}
    >
      <Typography
        noWrap={true}
        data-cy={'virtualized-list-row-title'}
        variant={'body1'}
      >
        {name}
      </Typography>
      {subCategoryCount ? (
        <Typography
          as={'span'}
          color={'textSecondary'}
        >{`(${subCategoryCount})`}</Typography>
      ) : null}

      {description ? (
        <Help as={'span'}>
          <Typography noWrap={true} variant={'body1'}>
            {description}
          </Typography>
        </Help>
      ) : null}
    </Stack>
  );
};
const CategoryList = ({ data, onEdit, filtered }) => {
  return (
    <VirtualizedList
      data={data}
      withSearch={filtered}
      isExpanded={() => filtered}
      getOptionLabel={renderLabel}
      getGroupLabel={renderLabel}
      secondaryAction={(option) => {
        return (
          <ListItemSecondaryAction
            style={{
              right: 0,
            }}
          >
            <CategoryActions
              data={option}
              onEdit={onEdit}
              actions={option?.actions}
            />
          </ListItemSecondaryAction>
        );
      }}
    />
  );
};

export default CategoryList;
